import qs from 'qs';
import { useQuery } from 'react-query';
import { network } from 'services/network';

import { QueryKeys } from 'api/queryKeys';

import { IAssignee } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/battlecards.types';

const queryFn = (params: QueryParams) => {
    const querystring = qs.stringify(params, { addQueryPrefix: true, skipNulls: true });

    const url = `api/bo/getRiskRegisterAuditLog${querystring}`;

    return network.get(url).then((response) => {
        return response.data;
    });
};

export const useQueryGetRiskRegisterAuditLog = (params: QueryParams) => {
    return useQuery<QueryFnResponse[], QueryError, QueryResponse[], [QueryKeys, unknown]>({
        queryKey: ['getRiskRegisterAuditLog', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.riskId),
    });
};

interface QueryParams {
    riskId: number;
}

export interface QueryResponse {
    attributeName: string;
    oldValue: string;
    newValue: string;
    changeDate: number;
    changedBy: Omit<IAssignee, 'id'>;
}

interface QueryFnResponse {
    attributeName: string;
    oldValue: string;
    newValue: string;
    changeDate: number;
    changedBy: Omit<IAssignee, 'id'>;
}
